import SongStore from '../stores/SongStore';
import MidiMapSelect from '../actions/MidiMapSelect';
import ParamUpdateMidiNormalized from '../actions/ParamUpdateMidiNormalized';
import Launchpad from './Launchpad';

class MidiLayer {

	constructor(dispatcher) {
		this.dispatcher = dispatcher;
		this._access = false;
		this._inputs = new Map();
		this._outputs = new Map();
		this._eventTypes = {
			0x80: 'note-off',
			0x90: 'note-on',
			0xa0: 'key-aftertouch',
			0xb0: 'control-change',
			0xc0: 'program-change',
			0xd0: 'channel-aftertouch',
			0xe0: 'pitch-bend',
			0xf1: 'timecode',
			0xf2: 'song-position',
			0xf3: 'song-select',
			0xf6: 'tune-request',
			0xf7: 'eox',
			0xf8: 'clock',
			0xfa: 'start',
			0xfc: 'stop',
			0xfe: 'active-sensing',
			0xff: 'reset'
		}


		this.launchpad = false;
	}

	start(callback) {

		this.bindings = this.dispatcher.getStore(SongStore).getMidiBindings();
		this.mapMode = false;

		this.dispatcher.getStore(SongStore).on('MIDI_BINDINGS_CHANGE', (bindings) => {
			this.bindings = this.dispatcher.getStore(SongStore).getMidiBindings();
		});

		this.dispatcher.getStore(SongStore).on('MIDI_MAP_MODE_CHANGE', (isEnabled) => {
			this.mapMode = isEnabled;
		});

		callback = callback || function(){};

		if (navigator.requestMIDIAccess) {
			navigator.requestMIDIAccess({
				sysex: false
			}).then((midiAccess) => {
				this._access = midiAccess;

				var fnc = this._MIDIMessageEventHandler.bind(this);

				var inputs = midiAccess.inputs.values();
				for (var input = inputs.next(); input && !input.done; input = inputs.next()) {
					this._inputs.set(input.value.id, input.value);
					input.value.onmidimessage = fnc;
				}

				var outputs = midiAccess.outputs.values();
				for (var output = outputs.next(); output && !output.done; output = outputs.next()) {
					this._outputs.set(output.value.id, output.value);
				}

				this._MIDICheckForLaunchpad();

				midiAccess.onstatechange = this._MIDIStateChange.bind(this);



				callback(true);

			}, function(err){
				console.error(err.message);
				callback(false);
			});
		} else {
			console.error("No MIDI support");
			callback(false);
		}
	}

	_MIDIStateChange(event) {

		var type = event.port.type;

		if(event.port.state == "connected") {
			if(type == "input") {
				this._inputs.set(event.port.id, event.port);
				event.port.onmidimessage = this._MIDIMessageEventHandler.bind(this);
			} else {
				this._outputs.set(event.port.id, event.port);
			}
			this._MIDICheckForLaunchpad();
		} else {
			if(type == "input") {
				this._inputs.delete(event.port.id);
			} else {
				this._outputs.delete(event.port.id);
			}
		}

	}

	_MIDICheckForLaunchpad() {


		var input, output;

		input = output = false;

		var re = /(Launchpad)/i;

		this._inputs.forEach((inp, key) => {
			if(inp.name.match(re) !== null) {
				input = key;
			}
		});

		this._outputs.forEach((inp, key) => {
			if(inp.name.match(re) !== null) {
				output = key;
			}
		});

		if(input !== false && output !== false) {

			if(this.launchpad) {
				this.launchpad.update();
			} else {
				this.launchpad = new Launchpad(this, this.dispatcher, input, output);
			}


		}
	}

	_MIDIMessageEventHandler(event) {
		var type, channel = 0, id = event.target.id;
		if (event.data[0] < 0xf0) {
			type = this._eventTypes[event.data[0] & 0xf0];
			channel = (event.data[0] & 0x0f) + 1;
		} else {
			type = this._eventTypes[event.data[0]];
		}
		if (type == 'note-on' && event.data[2] == 0) {
			type = 'note-off';
		}
		if (type == 'control-change' && event.data[1] > 119) {
			type = 'channel-mode';
		}

		var data = {
			type: type,
			channel: channel,
			data: event.data
		};

		if (channel) {

			if(this.launchpad && this.launchpad.blockInput(id)) {
				this.launchpad.receiveInput(data);
				return;
			}

			if (this.mapMode) {
				this.dispatcher.executeAction(MidiMapSelect, {
					midi_path: type + '-' + channel + '-' + event.data[1],
					midi_type: type,
					midi_channel: channel,
					midi_number: event.data[1]
				});
				return;
			}
			if (this.bindings.has(type + '-' + channel + '-' + event.data[1])) {

				var params = this.bindings.get(type + '-' + channel + '-' + event.data[1]);

				for (var i = params.length - 1; i >= 0; i--) {

					var value = 0;

					if (type == 'control-change' || type == 'note-on') {
						value = event.data[2]
					}

					this.dispatcher.executeAction(ParamUpdateMidiNormalized, {
						path: params[i].path,
						value: value
					});
				}


			}
		}
	}

	send(id, data, time) {
		var out;
		if(out = this._outputs.get(id)) {
			out.send(data, time || window.performance.now());
		}

	}
}

export default MidiLayer;